export default {
    'NuCalNumberOfNightsView': {
        'incrementButtonAria': 'Increase number of nights by 1',
        'decrementButtonAria': 'Decrease number of nights by 1',
    },
    'NuCalAnnouncerView': {
        'arrivalText' : 'the arrival date is [date].',
		'departureText' : 'The departure date is [date].'
    },
    'NuCalSingleCalendarView': {
        'nextLabel':'Next',
        'nextLabelAria': 'Next Month',
        'previousLabel':'Previous',
        'previousLabelAria': 'Previous Month'
    },
    'NuCalSelectView': {
        'departure': {
            'dayLabel': 'Day',
            'daySelectAria': 'Departure Day',
            'monthLabel': 'Month',
            'monthSelectAria': 'Departure Month',
            'yearLabel': 'Year',
            'yearSelectAria': 'Departure Year'
        },
        'arrival': {
            'dayLabel': 'Day',
            'daySelectAria': 'Arrival Day',
            'monthLabel': 'Month',
            'monthSelectAria': 'Arrival Month',
            'yearLabel': 'Year',
            'yearSelectAria': 'Arrival Year'
        }
    }
};